export enum EWholesaleCheaperTypes {
    SET_LOADING_STATUS = 'SET_LOADING_STATUS',
    SET_WHOLESALE_CHEAPER_DATA = 'SET_WHOLESALE_CHEAPER_DATA',
}
